module.exports = __webpack_public_path__ + "static/media/elbowFlexion.abe964f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/fppExercises/elbowFlexion.png
// module id = 2541
// module chunks = 0